import AddCircleOutline from '@mui/icons-material/AddCircleOutline'
import dayjs from 'dayjs'
import { DISPLAY_NAMES_OF_WEEKDAYS } from 'src/consumer/constants'
import { TimerCongratulatoryFlowPageStates } from '../utils'
import {
  PracticeDoneButton,
  StreakActionButton,
  StreakButtonsContainer,
  TimerStreakDayItem,
  TimerStreakDaysContainer,
  TimerStreakPageContainer,
} from './styledComponent'

export default function StreakPage({ backToPreviousPage, setNextPageState, isNotAnonymous }) {
  const today = dayjs()
  const currentDay = today.format('dddd').toLowerCase()

  function onDoneClick() {
    backToPreviousPage()
  }

  function goToAddPracticeState() {
    setNextPageState(TimerCongratulatoryFlowPageStates.ADD_PRACTICE)
  }

  return (
    <>
      <TimerStreakPageContainer>
        <TimerStreakDaysContainer>
          {Object.entries(DISPLAY_NAMES_OF_WEEKDAYS).map(([dayKey, dayData]) => (
            <TimerStreakDayItem key={dayKey} highlighted={currentDay === dayKey}>
              {dayData.firstLetter}
            </TimerStreakDayItem>
          ))}
        </TimerStreakDaysContainer>
        <StreakButtonsContainer>
          <StreakActionButton onClick={goToAddPracticeState} disabled={isNotAnonymous}>
            <AddCircleOutline />
            <span style={{ margin: 0 }}>
              {isNotAnonymous ? '1 Timer Added' : 'Add to favorites'}
            </span>
          </StreakActionButton>
          {/* <StreakActionButton onClick={openBlankJournal}>
            <Note /> <span style={{ margin: 0 }}>Write Notes</span>
          </StreakActionButton> */}
        </StreakButtonsContainer>
        <PracticeDoneButton onClick={onDoneClick}>Done</PracticeDoneButton>
      </TimerStreakPageContainer>
      {/* <WriteJournalModal
        open={journalAdd}
        onCloseFunction={closeJournalAdd}
        blankJournalData={blankJournalData}
      /> */}
    </>
  )
}
